module.exports = __webpack_public_path__ + "static/media/simple-skin-logo.203e524e.webp";